/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_DRUG,
  screenData: data,
});

//dispatch Quarter From
export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_DRUG,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_DRUG,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgDrug = (data) => ({
  type: actionTypes.GET_ERROR_MSG_DRUG,
  payload: data,
});
// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(dispatchErrorMsgDrug([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgDrug([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
//refresh data
export const refreshSubstanceAbuse = () => ({
  type: actionTypes.SET_REFRESH_DATA_DRUG,
  payload: {},
});
export const refreshSubstanceAbuseDisplay = () => ({
  type: actionTypes.SET_REFRESH_DATA_DRUG_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjDrug = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_DRUG,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_DRUG,
  payload: data,
});
//on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_DRUG,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
//selected report
export const dispatchReportType = (data) => ({
  type: actionTypes.SET_SELECTED_REPORT_DRUG,
  payload: data,
});
//substance abuse detail
export const dispatchSubstanceDetail = (data) => ({
  type: actionTypes.SET_SUBSTANCE_DRUG_DETAIL,
  payload: data,
});
//substance abuse summary
export const dispatchSubstanceSummary = (data) => ({
  type: actionTypes.SET_SUBSTANCE_DRUG_SUMMARY,
  payload: data,
});

export const getAbuseDetail = (value) => (dispatch) => {
  dispatch(dispatchSubstanceDetail([]));
  return axios
    .post(serviceEndPoint.GET_SUBSTANCE_ABUSE_DETAIL, value)
    .then((response) => {
      if (response.data.substanceAbuseDrugDetailGridVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchSubstanceDetail(response.data));
      }

      dispatch(dispatchSubstanceSummary([]));
    })
    .catch((response) => {
      dispatch(dispatchSubstanceDetail([]));
    });
};

export const getAbuseSummary = (value) => (dispatch) => {
  dispatch(dispatchSubstanceSummary([]));
  return axios
    .post(serviceEndPoint.GET_SUBSTANCE_ABUSE_SUMMARY, value)
    .then((response) => {
      if (response.data.substanceAbuseDrugSummaryGridVOList.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchSubstanceSummary(response.data));
      }

      dispatch(dispatchSubstanceDetail([]));
    })
    .catch((response) => {
      dispatch(dispatchSubstanceSummary([]));
    });
};
//substance abuse info

export const dispatchSubstanceInfo = (data) => ({
  type: actionTypes.SET_SUBSTANCE_DRUG_INFO,
  payload: data,
});
export const getAbuseInfo = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_SUBSTANCE_ABUSE_INFO, value)
    .then((response) => {
      return dispatch(dispatchSubstanceInfo(response.data));
    })
    .catch((response) => {
      dispatch(dispatchSubstanceInfo([]));
    });
};
